import { render, staticRenderFns } from "./AbsenceReason.vue?vue&type=template&id=31806684&"
import script from "./AbsenceReason.vue?vue&type=script&lang=js&"
export * from "./AbsenceReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports